import {FaqData} from "./FaqData";

export const FaqContent = (faq: FaqData) => {
    return (
        <details open={false} className={'faq-content-item'}>
            <summary>{faq.question}</summary>
            <p>{faq.answer}</p>
        </details>
    )
}